var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.approvalPage && _vm.isRejected && _vm.mainPage !== _vm.EDIT && _vm.menuRfqApprovalDetail?.canCreate && _vm.requester)?_c('div',[_c('div',{staticClass:"w-full p-4"},[_c('div',{},[_c('ButtonGista',{attrs:{"color":"secondary","customClass":"w-full"},on:{"click":_vm.clickEditApproval}},[_vm._v(" Edit")])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }